import axios from 'axios';
import { INSTRUCTOR_TIMETABLE, ROOM_TIMETABLE, SET_TIMETABLE } from '../../constants';
import { getApiUrl } from '../../helpers/api-url';
import createTimetablesWebApiHttpClient from '../../api/createTimetablesWebApiHttpClient';

const domain = getApiUrl();

const downloadReport = async (apiURL: string) => {
	
	createTimetablesWebApiHttpClient().get(apiURL, { responseType: 'blob' })
	.then((response) => {
        const localUrl = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = localUrl;
        link.setAttribute('download', 'TimetableReport.pdf');
        document.body.appendChild(link);
        link.click();
    });
};

export const exportSSRS = async (type: string, queryObjectID: number, termSchoolID: number, week: number) => {
	
	

    switch (type) {
        case SET_TIMETABLE:
            await downloadReport(`/ssrs/Report?reportTypeID=1&queryObjectID=${queryObjectID}&termSchoolID=${termSchoolID}&week=${week}`);
            break;

        case INSTRUCTOR_TIMETABLE:
            await downloadReport(`/ssrs/Report?reportTypeID=2&queryObjectID=${queryObjectID}&termSchoolID=${termSchoolID}&week=${week}`);
            break;

        case ROOM_TIMETABLE:
            await downloadReport(`/ssrs/Report?reportTypeID=3&queryObjectID=${queryObjectID}&termSchoolID=${termSchoolID}&week=${week}`);
            break;
    }
}


export const exportMultipleSetReport = async (termSchoolID: number, week: number, setIDs: readonly number[]) => {
    throw "Function Not Implemented"; // Legacy: Off 2025-06-12
};

export const exportMultipleInstructorReport = async (termSchoolID, week, instructorIDs) => {
    throw "Function Not Implemented"; // Refer to TTB-155
};

export const exportMultipleRoomReport = async (termSchoolID, week, roomIDs) => {
    throw "Function Not Implemented"; // Refer to TTB-155
};

export const exportDepartmentSetReport = async (termSchoolID: number, week: number, departmentID: number) => {
    throw "Function Not Implemented"; // Legacy: Off 2025-06-12
};

export const exportDepartmentInstructorReport = async (termSchoolID, week, departmentID) => {
    throw "Function Not Implemented"; // Refer to TTB-155
};